import {
  BottomSheetContainer,
  Colors,
  createUseBottomSheetModal,
  Flex,
  IconCheck,
  Typography,
  VerticalSpacing,
} from '@banhala/ui-kit';
import {
  SORTING_TYPE_IN_LIKE,
  type SortTypeInLike,
} from '../constants/sortingTypeInLike';

export const useSortSelectBottomSheet = createUseBottomSheetModal<
  { nextValue: SortTypeInLike },
  { selectedKey: string }
>(({ confirm, param }) => {
  return (
    <BottomSheetContainer>
      <VerticalSpacing size={8} />
      {SORTING_TYPE_IN_LIKE.map(item => {
        const selected = item.key === param.selectedKey;
        return (
          <Flex.Row
            key={item.key}
            alignItems={'center'}
            justifyContent={'space-between'}
            padding={{ horizontal: 16, vertical: 16 }}
            onPress={() => confirm({ nextValue: item })}
          >
            <Typography
              type={selected ? 'subtitle1' : 'body1'}
              color={selected ? 'content_pink_primary' : undefined}
            >
              {item.name}
            </Typography>
            {selected && (
              <IconCheck size={20} fill={Colors.content_pink_primary} />
            )}
          </Flex.Row>
        );
      })}
    </BottomSheetContainer>
  );
});
